(() => {
  if (customElements.get('waku-campaign')) return;
  customElements.define('waku-campaign', class extends HTMLElement {
    connectedCallback() { this.updateExpiry(); this.expiryTimer = setInterval(() => this.updateExpiry(), 60000); }
    disconnectedCallback() { clearInterval(this.expiryTimer); }
    updateExpiry() { const end = Date.parse(this.dataset.expires); this.hidden = !Number.isFinite(end) || Date.now() >= end; }
  });
})();
